/**
 * One table for Clu's chat in the agents look: a table Clu writes in its
 * answer (markdown) and a table a tool returns (people, lists, agents,
 * validation, a company) read the same, measured from Gumloop: 14/22.75 text,
 * 8 by 12 cells, a 1px border at 18% of the muted foreground and the header
 * row filled at 9%. The scroll wrapper fades the last 8px when the table is
 * wider than the chat.
 */
export const GUMLOOP_TABLE_SCROLL =
  'overflow-x-auto pr-[8px] [mask-image:linear-gradient(to_right,black_calc(100%-8px),transparent)]';

export const GUMLOOP_TABLE =
  'w-full border-collapse text-[14px] leading-[22.75px]';

export const GUMLOOP_TH =
  'border border-muted-foreground/[0.18] bg-muted-foreground/[0.09] px-[12px] py-[8px] text-left font-semibold';

export const GUMLOOP_TD =
  'border border-muted-foreground/[0.18] px-[12px] py-[8px] text-left align-top';
